angular.module('impactx.polling').service("PollingService", [
    'dataGen',
    '$interval',
    PollingService]);

function PollingService(dataGen, $interval) {
    var self = this;
    self.defaultPollingTime = 10000;
    self.activePolls = [];

    self.startPolling = function (name, url, callback, pollingTime) {
        var pollingRequest;
        if (!self.activePolls[name]) {
            pollingRequest = function () {
                return dataGen.getData({}, {}, url, null, true).then(callback);
            }
        }
        else {
            self.stopPolling(name);
            pollingRequest = function () {
                return dataGen.getData({}, {}, url, null, true).then(callback);
            };
        }

        pollingRequest();
        self.activePolls[name] = $interval(pollingRequest, pollingTime || self.defaultPollingTime);

        return self.activePolls[name];
    };

    self.stopPolling = function (name) {
        if (self.activePolls[name]) {
            $interval.cancel(self.activePolls[name]);
            delete self.activePolls[name];
        }
    };

    return {
        start: self.startPolling,
        stop: self.stopPolling
    };
}